import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { IPrice } from "~/types/IPrice";
import { usePriceData } from "~/hooks/usePriceData";

interface IQualityControlProps {
  isLegalPerson?: boolean;
  service?: IPrice;
}

const QualityControl: React.FC<IQualityControlProps> = (props) => {
  const { isLegalPerson, service } = props;
  const qualityControlPrice = usePriceData(isLegalPerson, service)

  return (
    <Screen
      title={<span>Оценка <StyledScreen.GreenText>качества</StyledScreen.GreenText></span>}
      bottomLine={true}
    >
      <Styled.Container>
        <Styled.Left>
          <Styled.IconWrapp>
            <Styled.IconBg>
              <Styled.IconPlace>
                <img src={process.env.PUBLIC_DIR + '/images/index_page/quality_standarts/icon_2.svg'} />
              </Styled.IconPlace>
            </Styled.IconBg>
          </Styled.IconWrapp>
        </Styled.Left>
        <Styled.Right>
          <Styled.Title>Не знаете, что думают клиенты?</Styled.Title>
          <Styled.Text>Подключите услугу «Оценка качества». После завершения разговора система попросит оценить работу сотрудника от 1 до 5. Звонки с низкой оценкой — первые претенденты на прослушку.</Styled.Text>
          <Styled.Price>{qualityControlPrice} / 30 дней</Styled.Price>
        </Styled.Right>
      </Styled.Container>
    </Screen>
  )
}

export { QualityControl }
